'use es6';

export const betaLocales = {};

export const betaPublicLocales = {
  'pt-pt': {
    language: 'pt-pt',
    beta: true,
    defaultLocale: 'pt-pt',
    availableLocale: ['pt-pt'],
  },
};
